<div portal-input-desconto>
  <div (click)="alertRodape()">
    <button
      type="button"
      class="discount-toggle"
      [disabled]="descontoControl.disabled"
      [attr.aria-label]="matPrefix === '%' ? 'Alterar desconto para reais' : 'Alterar desconto para percentual'"
      [title]="matPrefix === '%' ? 'Alterar para R$' : 'Alterar para %'"
      (mousedown)="$event.preventDefault()"
      (click)="switchPrefix(); $event.stopPropagation()"
    >{{ matPrefix }}</button>
    <input
      matInput
      type="text"
      inputmode="decimal"
      placeholder="0"
      [attr.id]="inputId"
      [attr.aria-label]="inputLabel + ' (' + matPrefix + ')'"
      [readonly]="blocked"
      [mask]="'separator.7'"
      [validation]="false"
      [dropSpecialCharacters]="true"
      [formControl]="descontoControl"
      (focusout)="applyDiscout($event)"
      (keyup.enter)="applyDiscout($event)"
      (blur)="onTouched()"
      [decimalMarker]="decimalMarkers"
      thousandSeparator=""
    />
    <button
      *ngIf="context !== 'footer'"
      type="button"
      class="discount-toggle"
      [disabled]="descontoControl.disabled"
      [attr.aria-label]="signal === '-' ? 'Alterar para acréscimo' : 'Alterar para desconto'"
      [title]="signal === '-' ? 'Alterar para acréscimo' : 'Alterar para desconto'"
      (mousedown)="$event.preventDefault()"
      (click)="switchSignal(); $event.stopPropagation()"
    >{{ signal }}</button>
  </div>
</div>
